export default "__VITE_ASSET__7fbf6229__"